import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPodcastaddictComponent } from './simple-icons-podcastaddict.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPodcastaddictComponent ],
    exports:      [ SimpleIconsPodcastaddictComponent ],
    bootstrap:    []
})
export class SimpleIconsPodcastaddictModule {}
